import { render, staticRenderFns } from "./EmailPreferenceSector.vue?vue&type=template&id=baebcba6&scoped=true&"
import script from "./EmailPreferenceSector.vue?vue&type=script&lang=js&"
export * from "./EmailPreferenceSector.vue?vue&type=script&lang=js&"
import style0 from "./EmailPreferenceSector.vue?vue&type=style&index=0&id=baebcba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baebcba6",
  null
  
)

export default component.exports